import template from './template.html'

angular
  .module('contabilidad.catalogosexternos')
  .component('contabilidadCatalogosexternosProductosag', {
    template,
    controller: Controller,
  })
Controller.$inject = ['CatalogosExternosProductosAg']

function Controller (CatalogosExternosProductosAg) {
  var $ctrl = this
  $ctrl.$onInit = $onInit

  $ctrl.editando = false

  function $onInit () {
    $ctrl.promise = CatalogosExternosProductosAg.get()
      .then(function (resolve) {
        $ctrl.data = resolve.data
      })
  }
}





// WEBPACK FOOTER //
// ./src/contabilidad/catalogosexternos/components/productosag/component.js